module.exports = __webpack_public_path__ + "img/frame_vertical.307bd7e.svg";